export const CommentsCountMixin = {
    computed:{
        CommentsCount() {
            return this.data.comments_count ?? 0
        }
    }
}


